/* Sales — a register's lines, yarn or waste, as the Sales page draws them. */

import { request } from './api'

export type Product = 'yarn' | 'waste'

/** One line of a register: a count (yarn) or a waste type (waste) on an
 *  invoice. `customer` and `tcs` are the waste register's; `count_ne`,
 *  `yarn_quality` and `tds` the yarn one's; each is null on the other. */
export interface SaleLine {
  product: Product
  invoice_no: string
  invoice_date: string
  line_no: number | null
  customer: string | null
  count_label: string
  count_ne: number | null
  yarn_quality: string | null
  bags: number | null
  quantity_kg: number
  price_per_kg: number
  ex_mill_value: number | null
  gst: number | null
  invoice_value: number | null
  tds: number | null
  tcs: number | null
  payable: number | null
}

export const sales = {
  lines: (product: Product = 'yarn') =>
    request<{ lines: SaleLine[]; months: string[] }>(`/sales/lines?product=${product}`),
  /** Replaces every invoice the sheet names with the sheet's lines. */
  upload: async (file: File, product: Product = 'yarn') => {
    const fd = new FormData()
    fd.append('file', file)
    return request<{
      ok: boolean; source: string; product: Product; rows: number; rows_replaced: number
      invoices: number; kg: number; first_date: string; last_date: string; warnings: string[]
    }>(`/sales/upload?product=${product}`, { method: 'POST', body: fd })
  },
}
